/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ShareEmailIcon = createIcon("ShareEmailIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: "80",
    cy: "80",
    r: "80",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 60h60v40H50V60Zm39.832 14.6L100 84m-29.832-9.4L60 84",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.013 61.37 83.645 78.865a6.416 6.416 0 01-7.29 0L50.987 61.37",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});